import { CustomTokenClaims } from './interfaces';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { take, filter } from 'rxjs/operators';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { TokenClaims } from '@azure/msal-common/browser';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
    private readonly userClaims = new BehaviorSubject<CustomTokenClaims | null>(null);
    userClaims$ = this.userClaims.asObservable();
    roles: string[] = [];

  constructor(
      private readonly msalService: MsalService,
      private readonly msalBroadcastService: MsalBroadcastService
  ) {}

  loadUserClaims(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(status => status === InteractionStatus.None),
        take(1)
      )
      .subscribe(() => {
        this.msalBroadcastService.msalSubject$
          .pipe(
            filter((msg: EventMessage) =>
              msg.eventType === EventType.LOGIN_SUCCESS ||
              msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS
            )
          )
          .subscribe((res) => {
            const authResult = res.payload as AuthenticationResult;
            this.userClaims.next(authResult.idTokenClaims ?? null);
          });

        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          const activeAccount = accounts[0];
          this.msalService.instance.setActiveAccount(activeAccount);

          const idTokenClaims = activeAccount.idTokenClaims as TokenClaims;
          if (idTokenClaims) {
            this.userClaims.next(idTokenClaims);
            
            const roles = idTokenClaims.roles || [];
            this.roles = roles;
          }
        }
      });
  }

  checkUserRoles(requiredRoles: string[]): boolean {
    const userRoles = this.roles;
    const hasRole = requiredRoles.some(role => userRoles.includes(role));

    return hasRole;
  }

  login(): void {
    const loginRequest: RedirectRequest = {
      scopes: [environment.apiScope]
    };
    
    this.msalBroadcastService.inProgress$
    .pipe(
      filter(status => status === InteractionStatus.None),
      take(1)
    )
    .subscribe(() => {      
      this.msalService.loginRedirect(loginRequest).subscribe({
        error: (error) => console.error('Erro no login:', error)
      });
    });
  }

  logout(): void {
    this.msalBroadcastService.inProgress$
    .pipe(
      filter(status => status === InteractionStatus.None),
      take(1)
    )
    .subscribe(() => {
      this.userClaims.next(null);
      this.msalService.logoutRedirect({
        postLogoutRedirectUri: environment.redirectUri,
      }).subscribe({
        error: (error) => console.error('Erro no logout:', error)
      });
    });
  }
}
